var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestiQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.6663C13.3333 13.1805 13.3333 14.4375 12.5523 15.2186C11.7712 15.9997 10.5141 15.9997 7.99999 15.9997C5.48583 15.9997 4.22875 15.9997 3.44771 15.2186C2.66666 14.4375 2.66666 13.1805 2.66666 10.6663C2.66666 8.15218 2.66666 6.8951 3.44771 6.11406C4.22875 5.33301 5.48583 5.33301 7.99999 5.33301C10.5141 5.33301 11.7712 5.33301 12.5523 6.11406C13.3333 6.8951 13.3333 8.15218 13.3333 10.6663Z",
    stroke: "#1CA8CB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.33301V15.3091C13.3333 20.6059 9.97906 25.0979 5.33334 26.6663",
    stroke: "#1CA8CB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 10.6663C29.3333 13.1805 29.3333 14.4375 28.5523 15.2186C27.7712 15.9997 26.5141 15.9997 24 15.9997C21.4859 15.9997 20.2288 15.9997 19.4477 15.2186C18.6667 14.4375 18.6667 13.1805 18.6667 10.6663C18.6667 8.15218 18.6667 6.8951 19.4477 6.11406C20.2288 5.33301 21.4859 5.33301 24 5.33301C26.5141 5.33301 27.7712 5.33301 28.5523 6.11406C29.3333 6.8951 29.3333 8.15218 29.3333 10.6663Z",
    stroke: "#1CA8CB",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 9.33301V15.3091C29.3333 20.6059 25.9791 25.0979 21.3333 26.6663",
    stroke: "#1CA8CB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestiQuote);
export default __webpack_public_path__ + "static/media/testi-quote.cd0153882b5abd3b68887a50d7e4d655.svg";
export { ForwardRef as ReactComponent };